import { Link } from 'react-router-dom';
import ArtistLinks from './ArtistLinks';
import { Icon } from './Icons';
import ShareButton from './ShareButton';

function formatListenCount(count) {
    const value = Number(count || 0);

    if (value >= 1000000) {
        return `${(value / 1000000).toFixed(1).replace('.0', '')}M`;
    }

    if (value >= 1000) {
        return `${(value / 1000).toFixed(1).replace('.0', '')}K`;
    }

    return String(value);
}

function TrackMeta({ track, className = '' }) {
    return (
        <div className={`bjnt-track-meta ${className}`}>
            {track.genre && (
                <span className="bjnt-track-meta__genre">
                    {track.genre}
                </span>
            )}

            {/* <span className="bjnt-track-meta__listens">
                {formatListenCount(track.plays)} listen{Number(track.plays || 0) === 1 ? '' : 's'}
            </span> */}
        </div>
    );
}

export default function TrackCard({
    track,
    index = 0,
    rank,
    variant = 'grid',
    onPlayTrack,
}) {
    if (variant === 'chart') {
        return (
            <article className="bjnt-track-card bjnt-track-card--chart">
                <div
                    className={`bjnt-track-card__rank ${rank % 2
                        ? 'bjnt-track-card__rank--yellow'
                        : 'bjnt-track-card__rank--blue'
                        }`}
                >
                    {rank}
                </div>

                <Link
                    to={`/track/${track.slug}`}
                    className="bjnt-track-card__cover"
                >
                    {track.cover ? (
                        <img src={track.cover} alt="" />
                    ) : (
                        <span />
                    )}
                </Link>

                <div className="bjnt-track-card__content">
                    <Link
                        to={`/track/${track.slug}`}
                        className="bjnt-track-card__title"
                    >
                        {track.title}
                    </Link>

                    <ArtistLinks
                        artists={track.artists}
                        fallback={track.artist}
                        className="bjnt-track-artists"
                    />

                    <TrackMeta track={track} />
                </div>

                <div className="bjnt-track-card__actions">
                    <button
                        type="button"
                        className="bjnt-track-card__play"
                        onClick={() => onPlayTrack?.(track, index)}
                    >
                        <Icon name="play" />
                    </button>

                    <ShareButton
                        track={track}
                        location="chart"
                        className="bjnt-track-card__share"
                    />
                </div>
            </article>
        );
    }

    return (
        <article className="bjnt-track-preview">
            <div className="bjnt-track-preview__actions">
                <button
                    type="button"
                    className="bjnt-track-preview__play"
                    onClick={() => onPlayTrack?.(track, index)}
                >
                    <Icon name="play" size={36} />
                </button>

                <ShareButton
                    track={track}
                    location="grid"
                    className="bjnt-track-preview__share"
                />
            </div>

            <Link
                to={`/track/${track.slug}`}
                className="bjnt-track-preview__cover"
            >
                {track.cover ? (
                    <img src={track.cover} alt="" />
                ) : (
                    <span />
                )}
            </Link>

            <div className="bjnt-track-preview__body">
                <h3>
                    <Link to={`/track/${track.slug}`}>
                        {track.title}
                    </Link>
                </h3>

                <ArtistLinks
                    artists={track.artists}
                    fallback={track.artist}
                    className="bjnt-track-artists"
                />

                <TrackMeta track={track} />
            </div>
        </article>
    );
}